var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex w-100"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('div', {
    staticClass: "spnod-admin__account--section"
  }, [_c('h5', {
    staticClass: "spnod-admin__account--header"
  }, [_vm._v("Personal Details")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("First Name:")]), _vm._v(" " + _vm._s(_vm.user.firstName))]), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Last Name:")]), _vm._v(" " + _vm._s(_vm.user.lastName))])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Phone:")]), _vm._v(" " + _vm._s(_vm.user.phone))]), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Email:")]), _vm._v(" " + _vm._s(_vm.user.email))])], 1), _vm._v(" "), (_vm.isPriveledgedUser) ? _c('b-row', [_c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("DOB:")]), _vm._v(" " + _vm._s(_vm.dob))]), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Notification Method:")]), _vm._v(" " + _vm._s(_vm.user.notificationMethod))])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isPriveledgedUser) ? _c('div', {
    staticClass: "spnod-admin__account--section"
  }, [_c('h5', {
    staticClass: "spnod-admin__account--header"
  }, [_vm._v("Address")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Street: ")]), _vm._v(_vm._s(_vm.street))]), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Street Line 2: ")]), _vm._v(_vm._s(_vm.street2))])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("City: ")]), _vm._v(_vm._s(_vm.city))]), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("State: ")]), _vm._v(_vm._s(_vm.state))])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Zip: ")]), _vm._v(_vm._s(_vm.zipcode))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spnod-admin__account--section"
  }, [_c('h5', {
    staticClass: "spnod-admin__account--header"
  }, [_vm._v("Groups")]), _vm._v(" "), _c('ul', _vm._l((_vm.user.groups), function(group) {
    return _c('li', {
      staticClass: "spnod-admin__form--list"
    }, [_vm._v(_vm._s(group.name))])
  }), 0)]), _vm._v(" "), (_vm.isPriveledgedUser) ? _c('div', {
    staticClass: "spnod-admin__account--section"
  }, [_c('h5', {
    staticClass: "spnod-admin__account--header"
  }, [_vm._v("Parent(s) / Guardian(s)")]), _vm._v(" "), (_vm.displayParents) ? _c('ul', _vm._l((_vm.user.parents), function(parent) {
    return _c('li', {
      staticClass: "spnod-admin__form--list"
    }, [_vm._v(_vm._s(parent.name))])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spnod-admin__account--section"
  }, [_c('h5', {
    staticClass: "spnod-admin__account--header"
  }, [_vm._v("Subscriptions")]), _vm._v(" "), (_vm.loadingSubscriptions) ? _c('div', [_vm._v("Loading...")]) : _c('div', [(_vm.isPriveledgedUser) ? _c('b-row', [_c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Plan: ")]), _vm._v(_vm._s(_vm.nickname))]), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Status: ")]), _vm._v(_vm._s(_vm.active))])], 1) : _vm._e(), _vm._v(" "), (_vm.sub && _vm.isPriveledgedUser) ? _c('b-row', [(!_vm.sub.cancel_at_period_end) ? _c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Due on: ")]), _vm._v(_vm._s(_vm.showTime(_vm.sub.current_period_end)))]) : _c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Ends on: ")]), _vm._v(_vm._s(_vm.showTime(_vm.sub.cancel_at)))])], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', [(_vm.forClient && !_vm.sub) ? _c('p', {
    staticClass: "text-primary cursor-pointer",
    on: {
      "click": _vm.handleSubscribe
    }
  }, [_vm._v("Subscribe this user")]) : _c('div', [(_vm.displayDisclaimer) ? _c('p', {
    staticClass: "text-danger pb-2"
  }, [_vm._v("Removing this user from their group will cancel their individual subscription!")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/subscriptions"
    }
  }, [_vm._v("Manage Subscriptions")])], 1)])], 1)], 1)]), _vm._v(" "), (_vm.isPriveledgedUser) ? _c('div', {
    staticClass: "spnod-admin__account--section"
  }, [_c('h5', {
    staticClass: "spnod-admin__account--header"
  }, [_vm._v("Nutritionist")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "pb-2"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Current Nutritionist: ")]), _vm._v(_vm._s(_vm.nutritionist))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isPriveledgedUser) ? _c('div', {
    staticClass: "spnod-admin__account--section"
  }, [_c('h5', {
    staticClass: "spnod-admin__account--header"
  }, [_vm._v("Dietary Restrictions")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "pb-2"
  }, [_vm._v(_vm._s(_vm.user.dietaryRequirements))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toggleEdit')
      }
    }
  }, [_vm._v("Edit")])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54613939","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/UserAccount/UserAccount.vue
// module id = /d7s
// module chunks = 2